import {
  MediaFields,
  MediaListParams,
} from "../../view/Modules/Medias/MediaDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

const removeDuplicateMediaFiles = (data: MediaFields) => {
  if (data instanceof FormData) {
    data.delete("song_file");
    data.delete("image");
  }

  return data;
};

export const MediaServices = {
  getMedias: (params: MediaListParams) => {
    return AxiosInstance.get(ContentApiRoutes.MEDIAS, { params });
  },
  createMedia: (data: MediaFields) =>
    AxiosInstance.post(
      ContentApiRoutes.CREATE_MEDIA,
      removeDuplicateMediaFiles(data)
    ),
  updateMedia: (id: number, data: MediaFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_MEDIA.replace(":id", id.toString()) +
        "?_method=PUT",
      removeDuplicateMediaFiles(data)
    ),
  viewMedia: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_MEDIA.replace(":id", id.toString())
    );
  },

  searchMedias: (media: string) =>
    AxiosInstance.get(ContentApiRoutes.MEDIAS + `?smart_search=${media}`),
};
